export const actions = {
  ESTADOS_USUARIOS_LOAD_REQUESTED: 'ESTADOS_USUARIOS_LOAD_REQUESTED',
  ESTADOS_USUARIOS_LOAD_SUCCEEDED: 'ESTADOS_USUARIOS_LOAD_SUCCEEDED',
  ESTADOS_USUARIOS_LOAD_FILED: 'ESTADOS_USUARIOS_LOAD_FILED',

  ESTADOS_USUARIOS_LOAD_BY_ID_REQUESTED: 'ESTADOS_USUARIOS_LOAD_BY_ID_REQUESTED',
  ESTADOS_USUARIOS_LOAD_BY_ID_SUCCEEDED: 'ESTADOS_USUARIOS_LOAD_BY_ID_SUCCEEDED',
  ESTADOS_USUARIOS_LOAD_BY_ID_FILED: 'ESTADOS_USUARIOS_LOAD_BY_ID_FILED',

  ESTADOS_USUARIOS_UPDATE_REQUESTED: 'ESTADOS_USUARIOS_UPDATE_REQUESTED',
  ESTADOS_USUARIOS_UPDATE_SUCCEEDED: 'ESTADOS_USUARIOS_UPDATE_SUCCEEDED',
  ESTADOS_USUARIOS_UPDATE_FILED: 'ESTADOS_USUARIOS_UPDATE_FILED',

  ESTADOS_USUARIOS_INSERT_REQUESTED: 'ESTADOS_USUARIOS_INSERT_REQUESTED',
  ESTADOS_USUARIOS_INSERT_SUCCEEDED: 'ESTADOS_USUARIOS_INSERT_SUCCEEDED',
  ESTADOS_USUARIOS_INSERT_FILED: 'ESTADOS_USUARIOS_INSERT_FILED',

  ESTADOS_USUARIOS_DELETE_REQUESTED: 'ESTADOS_USUARIOS_DELETE_REQUESTED',
  ESTADOS_USUARIOS_DELETE_SUCCEEDED: 'ESTADOS_USUARIOS_DELETE_SUCCEEDED',
  ESTADOS_USUARIOS_DELETE_FILED: 'ESTADOS_USUARIOS_DELETE_FILED',
}

export const getEstadosUsuariosAction = dispatch => {
  dispatch({
    type: actions.ESTADOS_USUARIOS_LOAD_REQUESTED,
  })
}

export const getEstadosUsuariosByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.ESTADOS_USUARIOS_LOAD_BY_ID_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertEstadosUsuarios = (dispatch, estadoUsuario) => {
  dispatch({
    type: actions.ESTADOS_USUARIOS_INSERT_REQUESTED,
    payload: estadoUsuario,
  })
}

export const onSubmitUpdateEstadosUsuarios = (dispatch, estadoUsuario) => {
  dispatch({
    type: actions.ESTADOS_USUARIOS_UPDATE_REQUESTED,
    payload: estadoUsuario,
  })
}

export const deleteEstadosUsuariosAction = (dispatch, id) => {
  dispatch({
    type: actions.ESTADOS_USUARIOS_DELETE_REQUESTED,
    payload: id,
  })
}
